/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Save_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to save changes" |
*
* @param {Profile_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_save_error = /** @type {((inputs?: Profile_Save_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Save_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la sauvegarde")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al guardar los cambios")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao salvar as alterações")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvataggio non riuscito")
	return /** @type {LocalizedString} */ ("Failed to save changes")
});